import React, { Fragment, useState, useRef, useEffect } from "react"
import { accessRole } from "../../../../../helpers/access_role"
import apiResponse from "../../../../../services/apiResponse"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Input, Label, 
} from "reactstrap"
import moment from "moment"

import TablePrimaryComponent from './Components/TablePrimaryComponent'
import DatePicker from "../../../../../helpers/ui/DatePicker"

const IndexView = (props) => {

    const [periode, setPeriode] = useState(
        { 
            start: moment().startOf('month').format('YYYY-MM-DD'), 
            end: moment().endOf('month').format('YYYY-MM-DD') 
        }
    )
    const [params, setParams] = useState([])

    const loadData = (pr) => {
        setParams(pr)
        setTimeout(() => {
            reloadActiveRef()
        }, 300);
    }

    const activeRef = useRef();

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    // Retrieve Data Pegawai by Admin / Pegawai
    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    const peg_detail = !accessRole('approve') ? (userdata != null ? userdata : "") 
    : (employeeSeleted != null ? employeeSeleted : "")

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end">
                        {
                            (accessRole('create')) ?
                                <Link to="?create">
                                    <Button color="primary">Koreksi Kehadiran</Button>
                                </Link>
                            : null
                        }
                        </div>
                        <CardTitle>Daftar Koreksi Kehadiran</CardTitle>
                        <CardSubtitle className="mb-3">
                            Kelola Koreksi Kehadiran
                        </CardSubtitle>
                        <hr />
                        <Row className="mb-1">
                            <label className="col-md-3">
                                NIP
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_nip
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Nama
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_name
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Jabatan
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_current_position_name
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Unit Kerja
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_current_work_unit_name
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Periode Mulai
                            </label>
                            <Col md="3">
                                {/* <Input
                                    name="start_period"
                                    placeholder="Periode Mulai..."
                                    type="date"
                                    errorMessage="Masukkan Periode Mulai"
                                    className="form-control"
                                    id="start_period"
                                    value={periode?.start}
                                    onChange={event => setPeriode({...periode, start: event.target.value })}
                                /> */}
                                <DatePicker 
                                    name="start_date"
                                    isWeekday={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholder="Tanggal Mulai"
                                    isAvForm={false}
                                    onChange={val => setPeriode({...periode, start: moment(val).format('YYYY-MM-DD') })}
                                    defaultValue={periode?.start}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <label className="col-md-3">
                                Periode Akhir
                            </label>
                            <Col md="3">
                                {/* <Input
                                    name="end_period"
                                    placeholder="Periode Akhir..."
                                    type="date"
                                    errorMessage="Masukkan Periode Akhir"
                                    className="form-control"
                                    id="end_period"
                                    value={periode?.end}
                                    onChange={event => setPeriode({...periode, end: event.target.value })}
                                /> */}
                                <DatePicker 
                                    name="end_date"
                                    isWeekday={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholder="Tanggal Mulai"
                                    isAvForm={false}
                                    onChange={val => setPeriode({...periode, end: moment(val).format('YYYY-MM-DD') })}
                                    defaultValue={periode?.end}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <Col md="3"></Col>
                            <Col md="6">
                                <Button 
                                    color="primary" 
                                    type="button"
                                    onClick={() => {
                                        loadData(periode)
                                    }}
                                >
                                    <i className="uil-search-alt"></i> Cari
                                </Button>
                                {' '}
                                <Button 
                                    color="warning" 
                                    type="button"
                                    onClick={() => {
                                        loadData([])
                                        setPeriode({ start: '', end: '' })
                                    }}
                                    >
                                    <i className="uil-refresh"></i> Reset
                                </Button>
                            </Col>
                        </Row>
                        <hr/>
                        <TablePrimaryComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} employee={peg_detail} params={params} />
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )

}

export default IndexView